import { render } from "./popUpReportarErro.vue?vue&type=template&id=1a99f947&scoped=true"
import script from "./popUpReportarErro.vue?vue&type=script&lang=js"
export * from "./popUpReportarErro.vue?vue&type=script&lang=js"

import "./popUpReportarErro.vue?vue&type=style&index=0&id=1a99f947&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a99f947"]])

export default __exports__